import Vue from 'vue';
import Vuex from 'vuex';

import account from './account';
import adminUser from './adminUser';
import quotation from './quotation';
import partner from './partner';
import stock from './stock';
import gateway from './gateway';
import device from './device';
import trigger from './trigger';
import shipping from './shipping';
import production from './production';
import faultReport from './faultReport';
import faultTypes from './faultTypes';
import aiModel from './aiModel';
import alarmWatch from './alarmWatch';

Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        account,
        adminUser,
        partner,
        stock,
        gateway,
        trigger,
        device,
        quotation,
        shipping,
        production,
        faultReport,
        faultTypes,
        alarmWatch,
        aiModel
    }
});
